import SoundCloudModal from './toolbar/soundCloudURLInputModal';

const Modals = {
  SOUND_CLOUD_URL_INPUT: 'sound-cloud-url-input',
};

const ModalsMap = {
  [Modals.SOUND_CLOUD_URL_INPUT]: SoundCloudModal,
};

export { Modals, ModalsMap };
